module.exports = __webpack_public_path__ + "static/media/LATTZOTH Image 3.87dd5e7a.png";